import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
} from '../Helpers/LoginHelper.js'

function ChallengeChoice({
  handleDisplayChange,
  mfaResponseData,
  phoneNumber,
  mode = '',
}) {
  const CHOICE_CHALLENGE_SMS = 'challenge-sms'
  const CHOICE_CHALLENGE_CALL = 'challenge-call'
  const [choice, setChoice] = useState(CHOICE_CHALLENGE_SMS)

  //such sadness, this code accounts for both scenarios from FYP and login challenge :(
  //value.routes.value used for login, value.routes for fyp
  const routes =
    (mfaResponseData?.value?.routes &&
      (mfaResponseData.value.routes.value || mfaResponseData.value.routes)) ||
    []

  const _smsOneTimePasscodeId = routes.find((route) => route.channel === 'SMS')
  const _callOneTimePasscodeId = routes.find((route) => route.channel === 'IVR')

  const smsOneTimePasscodeId = _smsOneTimePasscodeId?.id || null
  const callOneTimePasscodeId = _callOneTimePasscodeId?.id || null

  const onChoiceChange = (event) => {
    setChoice(event.target.value)
  }

  const onSubmitClicked = () => {
    if (mode === 'registration') {
      let channel = choice === CHOICE_CHALLENGE_SMS ? 'SMS' : 'IVR'
      handleDisplayChange(channel)
    } else {
      let id =
        choice === CHOICE_CHALLENGE_SMS
          ? smsOneTimePasscodeId
          : callOneTimePasscodeId
      handleDisplayChange(FORM_NAME_ONE_TIME_PASSCODE, { id: id })
    }
  }

  const onCancelledClicked = () => {
    if (mode === 'registration') {
      window.location.reload()
    } else {
      handleDisplayChange(FORM_NAME_LOGIN_FORM)
    }
  }

  return (
    <div
      className="u-marginBottom6gu"
      data-analytics-login-step="Verify Identity"
    >
      <div className="Grid">
        <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12 u-marginBottom6gu u-lg-marginBottom0 Content">
          <h2 className="u-marginBottom2gu u-marginTop0">
            Help us keep your account more secure
          </h2>
          {mode === 'fyp' && !smsOneTimePasscodeId && !callOneTimePasscodeId ? (
            <p>
              Contact a Columbia Threadneedle representative at{' '}
              <a aria-label="800. 2 4 8. 2 8 2 8" href="tel: 8002482828">
                800.248.2828
              </a>{' '}
              to proceed further.
            </p>
          ) : (
            <fieldset>
              <legend className="u-marginBottom4gu">
                Verify your identity
              </legend>
              <div className="Radio u-paddingLeft2gu u-marginBottom3gu u-flexCol">
                {(smsOneTimePasscodeId || mode === 'registration') && (
                  <>
                    <input
                      onChange={onChoiceChange}
                      className="Radio-button u-marginLeft0"
                      id={CHOICE_CHALLENGE_SMS}
                      type="radio"
                      value={CHOICE_CHALLENGE_SMS}
                      name="challenge-radio"
                      checked={choice === CHOICE_CHALLENGE_SMS}
                      data-analytics-login-option="SMS OTP"
                    />
                    <label
                      htmlFor={CHOICE_CHALLENGE_SMS}
                      className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
                    >
                      Text a code to: XXX.XXX.{phoneNumber.slice(-4)}
                    </label>
                  </>
                )}

                {(callOneTimePasscodeId || mode === 'registration') && (
                  <>
                    <input
                      onChange={onChoiceChange}
                      className="Radio-button u-marginLeft0"
                      id={CHOICE_CHALLENGE_CALL}
                      type="radio"
                      value={CHOICE_CHALLENGE_CALL}
                      name="challenge-radio"
                      checked={choice === CHOICE_CHALLENGE_CALL}
                      data-analytics-login-option="Call OTP"
                    />
                    <label
                      htmlFor={CHOICE_CHALLENGE_CALL}
                      className="Radio-label u-inlineBlock u-textSecondary u-marginBottom2gu u-marginLeft0"
                    >
                      Call me with a code at: XXX.XXX.{phoneNumber.slice(-4)}
                    </label>
                  </>
                )}
              </div>
              <div className="u-flex">
                <div className="u-flex">
                  <button
                    onClick={onSubmitClicked}
                    className="Button Button--primary Button--block u-marginRight5gu u-textNoTransform u-flex1of2"
                  >
                    Next
                  </button>
                  <button
                    onClick={onCancelledClicked}
                    className="Button Button--tertiary Button--block u-textNoTransform u-flex1of2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </fieldset>
          )}
        </div>
      </div>
    </div>
  )
}

ChallengeChoice.propTypes = {
  handleDisplayChange: PropTypes.func,
  mfaResponseData: PropTypes.object,
}

export default ChallengeChoice
